import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ParentButtonComponent } from '../../../../shared/components/ui/parent-button/parent-button.component';
import { InputFieldComponent } from '../../../../shared/components/ui/input-field/input-field.component';

export type StepUpTotpDialogData = {
  titleKey: string;
  bodyKey: string;
  confirmKey?: string;
};

@Component({
  selector: 'app-step-up-totp-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslatePipe,
    ParentButtonComponent,
    InputFieldComponent,
  ],
  templateUrl: './step-up-totp-dialog.component.html',
  styleUrl: './step-up-totp-dialog.component.scss',
})
export class StepUpTotpDialogComponent {
  #dialogRef = inject(MatDialogRef<StepUpTotpDialogComponent, string | null>);
  #fb = inject(FormBuilder);
  readonly data = inject<StepUpTotpDialogData>(MAT_DIALOG_DATA);

  readonly form = this.#fb.nonNullable.group({
    code: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
  });

  cancel(): void {
    this.#dialogRef.close(null);
  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.#dialogRef.close(this.form.controls.code.value.trim());
  }
}
